module.exports = __webpack_public_path__ + "static/media/sl.7c99150f.svg";